import React, { useEffect, useState } from 'react';
import { GridRowsProp, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IEmailNotification from '../../interfaces/IEmailNotification';
import CAppDataGrid from '../../../../app/components/CAppDataGrid';
import AppFormatDate from '../../../../app/features/format/AppFormatDate';
import langAdminUserEmailNotifications from '../../langs/langAdminUserEmailNotifications';

type CAdminUserEmailNotificationTableProps = {
	emailNotifications: IEmailNotification[];
};
const CAdminUserEmailNotificationTable = (props: CAdminUserEmailNotificationTableProps) => {
	const { emailNotifications } = props;

	const { t } = useTranslation();

	const [rows, setRows] = useState<GridRowsProp>();

	useEffect(() => {
		if (emailNotifications) {
			setRows(
				emailNotifications.map((x, index) => ({
					id: index,
					userName: x.user?.lastName,
					userFirstname: x.user?.firstName,
					userEmail: x.user?.email,
					documentName: x.document?.name,
					fundName: x.fund?.name,
					notificationSendDatetime: x.notification?.sendDatetime,
					notificationStatus: x.notification?.statusTag,
				})),
			);
		}
	}, [emailNotifications]);

	const columns: GridColDef[] = [
		{
			field: 'userName',
			headerName: t(langAdminUserEmailNotifications.column_user_name.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'userFirstname',
			headerName: t(langAdminUserEmailNotifications.column_user_firstname.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'userEmail',
			headerName: t(langAdminUserEmailNotifications.column_user_email.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'documentName',
			headerName: t(langAdminUserEmailNotifications.column_document_name.tag),
			width: 200,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'fundName',
			headerName: t(langAdminUserEmailNotifications.column_fund_name.tag),
			minWidth: 200,
			flex: 1,
			align: 'left',
			headerAlign: 'left',
		},
		{
			field: 'notificationSendDatetime',
			headerName: t(langAdminUserEmailNotifications.column_notification_send_datetime.tag),
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params: GridRenderCellParams) => <AppFormatDate date={params.value} />,
		},
		{
			field: 'notificationStatus',
			headerName: t(langAdminUserEmailNotifications.column_notification_status.tag),
			width: 120,
			align: 'left',
			headerAlign: 'left',
		},
	];

	return (
		<>
			{rows ? (
				<Box>
					<CAppDataGrid
						className="admin-email-notifications-table"
						rows={rows}
						columns={columns}
						autoHeight
						pagination
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default CAdminUserEmailNotificationTable;
